export const MASTODON_SOCIAL_DOMAIN = 'mastodon.social'
